export default __webpack_public_path__ + "static/media/1.3518f9cc.png";